import { useEffect, useState } from 'react';

import paths from 'routing/routes/_paths';
import useRouter from 'use-react-router';
import Select from 'common/components/form/inputs/Select';
import TableTopFilter from 'common/components/table/TableTopFilter';
import { components } from 'react-select';
import _sortBy from 'lodash/sortBy';

const pages = [
  {
    path: paths.enums.classification_societies,
    title: 'Classification Societies',
    value: 'classification_societies'
  },
  { path: paths.enums.airports, title: 'Airports', value: 'crew_airports' },
  { path: paths.enums.cargo, title: 'Cargo Grades', value: 'cargo_grades' },
  { path: paths.enums.cp_forms, title: 'CP Forms', value: 'cp_forms' },
  { path: paths.enums.fuel_grades, title: 'Fuel Grades', value: 'fuel_grades' },
  { path: paths.enums.ports, title: 'Ports', value: 'ports' },
  { path: paths.enums.routing_areas, title: 'Routing Areas', value: 'routing_areas' },
  { path: paths.enums.vessel_prefixes, title: 'Vessel Prefixes', value: 'vessel_prefixes' },
  { path: paths.enums.vessel_situations, title: 'Vessel Situations', value: 'vessel_situations' },
  { path: paths.enums.widget_types, title: 'Widget Types', value: 'widget_types' },
  { path: paths.enums.units, title: 'Units', value: 'units' },
  { path: paths.enums.countries, title: 'Countries', value: 'countries' },
  { path: paths.enums.nationalities, title: 'Nationalities', value: 'nationalities' },
  { path: paths.enums.currencies, title: 'Currencies', value: 'currencies' },
  {
    path: paths.enums.vessel_documents,
    title: 'Vessel Documents',
    value: 'vessel_documents',
    visibility: 'hidden'
  },
  {
    path: paths.enums.airlines,
    title: 'Airlines',
    value: 'airlines'
  },
  {
    path: paths.enums.agent_types,
    title: 'Agent Types',
    value: 'agent_types'
  },
  {
    path: paths.enums.vessel_types,
    title: 'Vessel Types',
    value: 'vessel_types'
  },
  {
    path: paths.enums.tools,
    title: 'Tools',
    value: 'tools'
  },
  {
    path: paths.enums.laytime_events,
    title: 'Laytime Events',
    value: 'laytime_events'
  },
  {
    path: paths.enums.ld_terms,
    title: 'LD Terms',
    value: 'ld_terms'
  },
  {
    path: paths.enums.crew_matrices,
    title: 'Crew Matrix',
    value: 'crew_matrices'
  },
  {
    path: paths.enums.event_types,
    title: 'Event Types',
    value: 'event_types'
  },
  { path: paths.enums.purchasing_groups, title: 'Purchasing Groups', value: 'purchasing_groups' },
  {
    path: paths.enums.purchasing_stores,
    title: 'Purchasing Stores',
    value: 'purchasing_stores'
  }
];

const groupedCrew = [
  { path: paths.enums.crew_statuses, title: 'Crew - Statuses', value: 'crew_statuses' },
  // {
  //   path: paths.enums.crew_evaluation_criteria_categories,
  //   title: 'Crew - Evaluation Criteria Categories',
  //   value: 'crew_evaluation_criteria_categories'
  // },
  // {
  //   path: paths.enums.crew_evaluation_criteria,
  //   title: 'Crew - Evaluation Criteria',
  //   value: 'crew_evaluation_criteria'
  // },
  {
    path: paths.enums.crew_identifiers,
    title: 'Crew - Identifiers',
    value: 'crew_identifiers'
  },
  { path: paths.enums.crew_rank, title: 'Crew - Rank', value: 'crew_rank' }
];

const groupedOptions = [...groupedCrew, ...pages];

const alias = {
  [paths.enums.ports_map]: paths.enums.ports,
  [paths.enums.purchasing_stores_unlinked]: paths.enums.purchasing_stores,
  [paths.enums.vessel_subtypes]: paths.enums.vessel_types,
  [paths.enums.vessel_type_categories]: paths.enums.vessel_types
};

const EnumsDropdown = () => {
  const [active, setActive] = useState(null);
  const { location, history, match } = useRouter();

  let index = match.path.indexOf(':');
  const staticPath =
    index !== -1 ? match.path.substring(0, match.path.lastIndexOf('/', index)).trim() : match.path;
  const path = staticPath || location.pathname;

  useEffect(() => {
    const activePage = groupedOptions
      .map(page => {
        if (page.label) {
          return page.options.find(innerPage => innerPage.path === path);
        } else {
          return groupedOptions.find(page => page.path?.includes(alias[path] || location.pathname));
        }
      })
      .filter(item => item !== undefined)
      .find(item => item.path?.includes(alias[path] || location.pathname));

    if (activePage) {
      setActive(activePage);
    }
  }, [location.pathname, path]);

  const onChange = (_, value) => {
    history.push({ pathname: value.path });
  };

  return (
    <TableTopFilter>
      <Select
        className="ms-1"
        getOptionValue={option => option.value}
        getOptionLabel={option => option.title}
        value={active?.value}
        options={_sortBy(groupedOptions, ['title'])}
        onChange={onChange}
        hideSelectedOptions={true}
        components={{ Option }}
        size="lg"
      />
    </TableTopFilter>
  );
};

const Option = props => {
  return (
    props.data.visibility !== 'hidden' && (
      <components.Option className="enums-options" {...props}>
        {props.data.title}
      </components.Option>
    )
  );
};

export default EnumsDropdown;
